import siteConfig from '../../../../../configs/site/main';

const config = {
  ...siteConfig,
};

export default config;

export const helpCenterUrl = 'https://support.blofin.com';
export const chatbotWsBaseDomain = 'ws-cs.blofin.com';
export const chatbotCdnFallback = 'https://s2.blofin.com';

export const CATEGORY_REDIRECT_MAP: Record<number, string> = {
  7338085860495: '/support/Terms',
  7337929824655: '/support/FAQ',
  6149031297551: '/support/Announcement',
  6200477770255: '/support/FAQ/Top-Questions',
  6200508570895: '/support/FAQ/Beginners-Guide',
};
